import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTenantsDataAction } from "../actions/adminPermissionsAction";
import { getUsers, insertUpdateUser, deleteUserId } from "../../config/apiConfig";
import { Modal } from "react-bootstrap";
import { SBAComboBox, SBADropDown } from "../UiComponents/SBADropDown";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { ToastContainer, toast } from "react-toastify";
import { sbaAxios } from "../utils/sbaAxios";
import {SBNotify} from '../utils/sbNotify';
import { SBAAGgrid } from '../UiComponents/SBAAGgrid';


export const Users = () => {

  const [render, setRender] = useState(true);
  const [usersData, setUsersData] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newUserId, setNewUserId] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [newTenantName, setNewTenantName] = useState("");
  const [newFirstName, setNewFirstName] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [newDisplayName, setNewDisplayName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [showDrawer, setshowDrawer] = useState(false);
  const [selectedTenant,setSelectedTenant]=useState();
  const [drawerTenant,setDrawerTenant]=useState({});
    const [showModal, setShowModal] = useState(false);
    const [UserId, setUserId] = useState();
    const ColumnFilteroption = false;

  const dispatch = useDispatch();

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const tenantsData = Gstate?.AdminPermissions?.TenantData || [];
  

  useEffect(() => {
    dispatch(getTenantsDataAction());
  }, [render]);

  const toggleModal = () => {
   // setIsModalOpen(!isModalOpen);
    setshowDrawer(true);
    setNewUserId("");
    setNewUserName("");
    setNewTenantName("");
    setNewFirstName("");
    setNewLastName("");
    setNewDisplayName("");
    setNewEmail("");
   // setSelectedTenant({});
  };

  const TenantsDropDownChange = (e) => {
    setTenantId(e.value.TenantId);
    setDrawerTenant(e.value);
    setSelectedTenant(e.value);
  }

    const handleAddUsers = async () => {
       
    let error=false;
        let errorMsg = '';
        const re =
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(drawerTenant.TenantId && drawerTenant.TenantName)
    {
      if(newUserName)
      {
        if(newFirstName)
        {

        }
        else
        {
          error=true;
          errorMsg="Please Enter the First Name"
        }
      }
      else{
        error=true;
        errorMsg="Please Enter the User Name"
        }



    }
    else{
      error=true;
      errorMsg="Please select Tenant"
    }

        if (newEmail !== "") {
            {
                if (re.test(newEmail))  {
                    error = false;
                }
                else {
                    error = true;
                    errorMsg = "Please Enter Valid Email"
                }
            }

        }
        else {
            error = true;
            errorMsg = "Please Enter the Email"
        }

    if(error){
      toast.warning(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
    else{
      const data = {
        "userId": newUserId == "" ? null : newUserId,
        "firstName": newFirstName,
        "lastName": newLastName,
        "displayName": newDisplayName,
        "tenantId": drawerTenant.TenantId,
        "tenantName": drawerTenant.TenantName,
        "email": newEmail,
        "userName": newUserName,
        "password": "string",
        "modifiedBy": 32
      }
      try {
        await 
        sbaAxios({
          url: `${insertUpdateUser}`,
          method: 'post',
          data: data,
        }).then((response) => {

        console.log(response)
        if(response === -999)
        {
          SBNotify({type:'warning',Msg:"Email ID Already exist"});
          return
        }
            if (newUserId ==="") {
              SBNotify({type:'success',Msg:"User has been added successfully"});
          closeModal();
            }
            else  {
              SBNotify({ type: 'success', Msg: "User Details Updated successfully" });
                closeModal();
            }
        usersListData();
      })
      } catch (error) {
        console.error("Error updating services:", error);
      }
    }
  };

  const closeModal = () => {
      setshowDrawer(false);
      setShowModal(false);
      setIsModalOpen(false);
  };

  const EditButtonRenderer = (props) => {
    const userData = props.data;
    const handleEditClick = () => {
      onEditButtonClick(userData);
    };

    return (
      <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={handleEditClick}></i>
      </div>)
  };
  const onEditButtonClick = (userData) => {
    //setIsModalOpen(!isModalOpen);
    console.log(userData,'userdata');
    setshowDrawer(true);
    setNewUserId(userData.UserId);
    setNewUserName(userData.UserName);
    setNewTenantName(userData.TenantName);
    setNewFirstName(userData.FirstName);
    setNewLastName(userData.LastName);
    setNewDisplayName(userData.DisplayName);
    setNewEmail(userData.Email);
    setDrawerTenant({TenantId:userData.TenantId,TenantName:userData.TenantName});
  };
  const DeleteButtonRenderer = (props) => {
    const userId = props.data.UserId;
    const handleDeleteClick = () => {      
        setShowModal(true);
        setUserId(userId)
    };

    return (
      <div className="actions-cell">
        <i className="fas fa-trash" style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
      </div>
    );
  };

    const onDeleteButtonClick = () => {
        setShowModal(false);
        sbaAxios({
          url: `${deleteUserId}${UserId}`,
          method: 'get',
      }).then((response) => {
            if (response === -4444) {
                closeModal();
                toast.error("Delete Failed, Tenant Mapped with this User", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else if (response.data === -3333) {
                closeModal();
                toast.error("Delete Failed, Role Mapped with this User", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else {
                closeModal();
                toast.success("User Delete Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setTimeout(() => {
                    usersListData();

                }, 100);

            }

        })
            .catch(error => {
                console.error('Error deleting data:', error);
            });
    }

  const usersGridRowData = Array.isArray(usersData)
    ? usersData.map((row) => {
      const rowDataItem = {
        UserId: row.UserId,
        FirstName: row.FirstName,
        LastName: row.LastName,
        DisplayName: row.DisplayName,
        TenantId: row.TenantId,
        TenantName: row.TenantName,
        Email: row.Email,
        UserName: row.UserName,
        Password: row.Password,
        ModifiedBy: row.ModifiedBy,
      };
      return rowDataItem;
    })
    : [];

  const listofUsersColumnDefs = [
    { headerName: "Tenant Name", field: "TenantName" , filter: "agTextColumnFilter"},
    { headerName: "User Name", field: "UserName"  , filter: "agTextColumnFilter"},
    { headerName: "Password", field: "Password", hide: true , filter: "agTextColumnFilter" },
    { headerName: "First Name", field: "FirstName"  , filter: "agTextColumnFilter" },
    { headerName: "Last Name", field: "LastName"  , filter: "agTextColumnFilter"},
    { headerName: "Display Name", field: "DisplayName"  , filter: "agTextColumnFilter" },
    { headerName: "Email", field: "Email"  , filter: "agTextColumnFilter"},
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: EditButtonRenderer,
      maxWidth: 100,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: DeleteButtonRenderer,
    },
  ];
  useEffect(() => {
    usersListData();
  }, [tenantId]);

  const usersListData = async () => {
    try {
      const response = await   sbaAxios({
        url: `${getUsers}?tenantId=${tenantId}`,
        method: 'get',
    });
      const data = response;
      setUsersData(data);
    } catch (error) {
      console.error("Error fetching usersListData from API:", error);
    }
  };
  return (
    <>
        <br></br>
        <div className="col-lg-4">
          <label className="mb-1 ms-2 fw-semibold fs-12">
            Select Tenant
          </label>
          <div>
            <SBAComboBox
              data={tenantsData}
              textField={'TenantName'}
              valueField={'TenantId'}
              onChange={TenantsDropDownChange}
              // options={"0"}
              value={selectedTenant}
            />
          </div>
        </div>
        <div className="row flex-wrap">
          <div className="header-container m-2 fs-12 col-lg-12">
            <b> Available Users </b>
            <button className="p-sm-btn mx-1" onClick={toggleModal}>
              <i className="fa-solid fa-plus" /> Add
            </button>
          </div>
          <div className="ag-theme-alpine m-1 col-lg-12" style={{ height: 550 }}>           
                  {SBAAGgrid(listofUsersColumnDefs, usersGridRowData, ColumnFilteroption)}
          </div>
        </div>
     
      <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Add / Update Users'}>
        <div>
          <div>
            <label className="header-container m-1">
              <b>Tenant Name</b>
            </label>
            <div>
            <SBAComboBox
              data={tenantsData}
              textField={'TenantName'}
              valueField={'TenantId'}
              className='w-75'
              options={"0"}
              popupSettings={{ className: 'modalDD' }}
              value={drawerTenant}
              onChange={(e)=>{setDrawerTenant(e.value)}}
            />          
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>User Name</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newUserName}
                onChange={(e) => setNewUserName(e.target.value)}
              />
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>First Name</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newFirstName}
                onChange={(e) => setNewFirstName(e.target.value)}
              />
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>Last Name</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newLastName}
                onChange={(e) => setNewLastName(e.target.value)}
              />
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>Display Name</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newDisplayName}
                onChange={(e) => setNewDisplayName(e.target.value)}
              />
            </div>
            <br></br>
            <label className="header-container m-1">
              <b>Email</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="mt-4">
          <button className="s-sm-btn mx-1" onClick={closeModal}>
            Cancel
          </button>
          <button className="p-sm-btn mx-1" onClick={handleAddUsers}>
            Save
          </button>
          </div>
      </div>
          </SBADrawer >
          { <Modal show={showModal}  >
              <Modal.Header closeButton onClick={closeModal}>
                  <Modal.Title>Do you want to delete the selected User?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <p>Selected User and their mapping with Tenent and Role will be deleted permenantly. Are you sure?</p>
              </Modal.Body>
              <Modal.Footer>
                  <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                  <button className='p-sm-btn mx-1' onClick={onDeleteButtonClick} >
                      Yes
          </button>
              </Modal.Footer>
          </Modal> }
    </>
  );
};
